import React, { useState, useEffect, useLayoutEffect } from 'react';
import { View, Text, TouchableOpacity, ScrollView } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import { useNavigation } from '@react-navigation/native';
import { useSelector, useDispatch } from 'react-redux';
import { fontFamily } from '../../helpers/fontFamily';
import Toast from '../../commons/Toast';
import useRuleManagement from '../../helpers/useRuleManagement';
import { saveRule } from '../../actions/rulesActions';
import RuleEditor from './RuleEditor';

const AutomationRulesScreen = ({ route }) => {
  const navigation = useNavigation();
  const dispatch = useDispatch();
  const userInfo = useSelector((state) => state.user.userInfo);

  const {
    saving, saveErrors,
    editingRule, showEditor,
    showToast, toastMessage, hideToast,
    handleSave, handleEdit, handleCreateNew, handleCancelEditor,
    handleStarterSelected,
  } = useRuleManagement();

  const [windowWidth, setWindowWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 900
  );

  const screenTitle = editingRule?.id ? 'Edit Rule' : 'Create New Rule';

  useLayoutEffect(() => {
    if (typeof window === 'undefined') return;
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (route?.params?.openCreate) {
      if (route?.params?.starter) {
        handleStarterSelected(route.params.starter);
      } else {
        handleCreateNew();
      }
    }
  }, [route?.params?.openCreate]);

  useEffect(() => {
    if (route?.params?.editRule) {
      handleEdit(route.params.editRule);
    }
  }, [route?.params?.editRule]);

  const handleSaveAndReturn = async (ruleData) => {
    if (route?.params?.returnToSettings) {
      const result = await dispatch(saveRule(ruleData));
      if (result?.success) {
        navigation.goBack();
      }
    } else {
      await handleSave(ruleData);
    }
  };

  const handleCancel = () => {
    if (route?.params?.returnToSettings) {
      navigation.goBack();
    } else {
      handleCancelEditor();
    }
  };

  const headerHeight = windowWidth >= 900 ? 64 : 40;

  return (
    <View style={{ flex: 1 }}>
      <LinearGradient
        start={{ x: 0, y: 1 }}
        end={{ x: 0, y: 0 }}
        colors={['#142130', '#304454']}
        style={{
          width: '100%',
          height: headerHeight,
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: windowWidth < 900 ? 'flex-end' : 'center',
          paddingBottom: 2,
        }}
      >
        <View style={{ flexDirection: 'row', alignItems: 'center' }}>
          <TouchableOpacity
            onPress={() => route?.params?.openMenuDrawer?.()}
            style={{ marginLeft: 20, justifyContent: 'center', width: 30 }}
          >
            <i className="icon-menu" style={{ color: 'white', fontSize: 24, marginLeft: -10 }} />
          </TouchableOpacity>
          {windowWidth > 900 && userInfo && (
            <View style={{ flexDirection: 'column', marginLeft: 10 }}>
              <Text style={{ fontFamily: fontFamily.font500, color: '#fff', fontSize: 16, textTransform: 'uppercase', lineHeight: 15, marginTop: 4 }}>
                {userInfo.username}
              </Text>
              <Text style={{ fontFamily: fontFamily.font700, color: '#fff', fontSize: 16, textTransform: 'uppercase' }}>
                {userInfo.current_tenant}
              </Text>
            </View>
          )}
        </View>

        <Text style={{ color: '#fff', fontFamily: fontFamily.font700, fontSize: 18, marginRight: windowWidth < 900 ? '3rem' : '4rem' }}>
          {screenTitle}
        </Text>

        <View style={{ marginRight: '1%' }} />
      </LinearGradient>

      <LinearGradient
        colors={['#111C29', '#253C57', '#5C778F', '#5C778F', '#253C57', '#111B27']}
        locations={[0.09, 0.19, 0.43, 0.58, 0.78, 0.92]}
        start={{ x: 0, y: 0 }}
        end={{ x: 1, y: 1 }}
        style={{ flex: 1 }}
      >
        <ScrollView contentContainerStyle={{ paddingTop: 48, paddingHorizontal: 20, paddingBottom: 40, alignItems: 'center' }}>
          <LinearGradient
            colors={['rgba(17, 28, 41, 0.7)', 'rgba(37, 60, 87, 0.55)', 'rgba(92, 119, 143, 0.45)', 'rgba(92, 119, 143, 0.45)', 'rgba(37, 60, 87, 0.55)', 'rgba(17, 27, 39, 0.7)']}
            locations={[0.09, 0.19, 0.43, 0.58, 0.78, 0.92]}
            start={{ x: 0, y: 0 }}
            end={{ x: 1, y: 1 }}
            style={{ borderRadius: 20, padding: 20, minHeight: 300, width: windowWidth >= 900 ? '70%' : '100%', boxShadow: '0px 0px 10px 0px rgba(255, 255, 255, 0.2)' }}
          >
            {showEditor && (
              <RuleEditor
                rule={editingRule}
                onSave={handleSaveAndReturn}
                onCancel={handleCancel}
                saving={saving}
                saveErrors={saveErrors}
              />
            )}
          </LinearGradient>
        </ScrollView>
      </LinearGradient>

      <Toast visible={showToast} message={toastMessage} onHide={hideToast} />
    </View>
  );
};

export default AutomationRulesScreen;
